export { getAccompanimentsSearchServiceList } from './getAccompanimentsSearchServiceList'



// WEBPACK FOOTER //
// ./src/services/nursingHome/accompaniments/accompanimentsSearch/index.ts